module.exports = __webpack_public_path__ + "d72f60e97335610f581e740ccbb55a29.pdf";